// extracted by mini-css-extract-plugin
export default {"icon":"UpcomingAppointSection_icon__vwyD7"};